export const numberFormat = (value, thousand = ",", decimalPlace = 2) => {
  if (value === null || value === undefined || value === "") return "";

  const number = parseFloat(value);
  if (isNaN(number)) return value;

  return number.toLocaleString("en-US", {
    minimumFractionDigits: decimalPlace,
    maximumFractionDigits: decimalPlace,
  }).replace(/,/g, thousand);
}